// import { $req } from "../utils";
import request from '../utils/request'
export default {
	/*-------------------------------------------------------------设备start-----------------------------------------------------------  */
	//项目列表
	getProjectList({ ...params }) {
		return request({
			method: 'POST',
			url: `/pmp/project/forbpc/getList`,
			data: params
		})
	},
	//设备列表查询-姜飞
	queryDeviceList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/queryDeviceList`,
			data: params
		})
	},
	//设备预算填报保存-姜飞
	saveDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/saveDeviceBudget`,
			data: params
		})
    },
    //设备预算填报查询-姜飞
	queryDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/queryDeviceBudget`,
			data: params
		})
	},
	//设备预算删除-姜飞
	deleteDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/deleteDeviceBudget`,
			data: params
		})
	},
	//设备预算编辑-姜飞
	editDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/updDeviceBudget`,
			data: params
		})
	},
	// 新增设备保存
	saveAddDevices({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/createDeviceKindInfo`,
			data: params
		})
    },
    //设备预算编辑-姜飞
	addDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/saveCommonDeviceBudget`,
			data: params
		})
	},
	// 
	
	//归口设备预算查询-姜飞
	funDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/querySummaryDeviceBudgetList`,
			data: params
		})
	},
	//归口设备预算保存-姜飞
	funDeviceSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/saveSummaryDeviceBudget`,
			data: params
		})
	},
	//归口设备预算保存-姜飞
	publishDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			// url: `/bpc/common/deviceBudget/publishDeviceBudget`,
			url: `/bpc/common/deviceBudget/publishSummaryDeviceBudget`,
			data: params
		})
    },
    // 各部门项目功能下的设备预算列表查询
    queryCommonDeviceBudgetList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/queryCommonDeviceBudgetList`,
			data: params
		})
	},
	// 归口设备审核-李旭
	reviewDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/deviceBudget/reviewDeviceBudget`,
			data: params
		})
	},
}